import "./SectionStatBlocks.css"

const SectionStatBlocks = (statBlockData: any) => {
  return (
    <div className="row">
      {statBlockData?.data?.statBlocksCollection?.items?.length > 0 && (
        <div className="section-stat-blocks flex flex-col md:flex-row justify-between">
          {statBlockData?.data?.statBlocksCollection?.items?.map((statBlock: any, index: number) => {
            return (
              <div key={index} className="px-6 py-12 md:px-12 lg:py-24 my-4 stat-block flex justify-center align-center flex-col text-center rounded-lg">
                <span className="text-4xl font-bold uppercase inline-block mb-4">{statBlock?.headline}</span>
                <p className="text-base">{statBlock?.description}</p>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default SectionStatBlocks